var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"form-block base-shadow"},[_c('h4',{staticClass:"form-block-title clearfix"},[_vm._v(" "+_vm._s(_vm.name)),_vm._t("control")],2),_c('section',{staticClass:"form-block-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }